module.exports = __webpack_public_path__ + "static/media/pencil2.98cedd79.svg";